import { Popover } from "antd";
import $ from "jquery";
import moment from 'moment';
import 'moment-timezone';
import React, { useState, useEffect, useRef } from 'react';
import Moment from 'react-moment';
import SessionManager from '../routes/SessionManager';

const Notifications = () => {

  const [zoneEventsInfo, setZoneEventsInfo] = useState([]);
  const [events_count, setEventsCount] = useState(0);
  const [user, setUser] = useState(null);
  let isMount = useRef(true);

  let sessionManager = new SessionManager();
  var user1 = sessionManager.readCookie('user');
  let timezone = user1.site_selected.site_iana_timezone;
  let fetchNotifications = !['/dashboard-exec'].includes(window.location.pathname);

  useEffect(() => {

    if (!fetchNotifications) {
      return;
    }

    let myDefaultWhiteList = $.fn.tooltip.Constructor.Default.whiteList;
    myDefaultWhiteList.time = ['datetime'];
    myDefaultWhiteList.span = ['zone', 'ai_event'];
    prepareNavData();
    //Refresh Notifications when the user is on dashboard page based on the event triggered
    $(document).on("refresh_notifications", (e) => { refreshNotifications() });
    //if the user is not on Dashboard page,refresh the Notifications based on Timer in the background
    if (!window.location.href.endsWith("/dashboard")) {
      setInterval(() => {
        refreshNotifications();
      }, 125000);
    }

    return () => isMount.current = false
  }, []);

  useEffect(() => {
    if (user)
      prepareNavData();
  }, [user]);

  let refreshNotifications = () => {
    var sessionMgr = new SessionManager();
    var user = sessionMgr.readCookie('user');
    if (user && user.site_selected) {
      if (isMount.current)
        setUser(user);
    } else {
      setTimeout(function () {
        //console.log('No zone info available ...retries after 3 secs');
        refreshNotifications();
      }, 3000);
    }
  }

  let prepareNavData = async () => {
    if (!user || !user.zones) {
      setTimeout(function () {
        //console.log('No zone info available ...retries after 3 secs');
        refreshNotifications();
      }, 3000);
      return;
    } else {
      timezone = user.site_selected.site_iana_timezone;
      var zones = user.zones;
      let location_map = {}
      for (let zone of zones)
        location_map[zone.location_id] = zone;

      let zone_events_all = await fetchZonesEvents(Object.keys(location_map));
      let events_count = 0;
      for (let location_id in zone_events_all) {
        let zone_events = zone_events_all[location_id];
        events_count += zone_events.events.length;
        zone_events.zone = location_map[location_id];
        zone_events_all[location_id] = zone_events;
      }
      if (isMount.current) {
        setZoneEventsInfo(Object.values(zone_events_all));
        setEventsCount(events_count);
      }
    }
  }

  let navigate = (zone_selected, sec_timestamp, timestamp) => {
    let user = sessionManager.readCookie('user');
    let site_selected = {};
    let ai_event = { sec_timestamp, timestamp };

    if (user.site_locations) {
      for (let site of user.site_locations) {
        if (site.site_id === zone_selected.site_id) {
          site_selected = site;
        }
      }
    }

    sessionManager.storeCookie("user", { ...user, site_selected, zone_selected, ai_event });
    window.location.href = "/dashboard/zone-history";
  }

  let fetchZonesEvents = (location_ids) => {
    return new Promise((resolve, reject) => {
      var data = {
        customer_id: user.customer_id,
        site_id: user.site_selected.site_id,
        user_login: user.user_login,
        user_token: user.user_token,
        location_ids: location_ids
      }
      let siteSelected = { ...user.site_selected };
      $.ajax(
        {
          url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/event/fetch',
          type: 'POST',
          contentType: "application/json; charset=utf-8",
          dataType: "json",
          data: JSON.stringify(data)
        }
      ).then(
        (res) => {
          if (res.status && res.status.code === 200) {
            var timezone = siteSelected.site_iana_timezone;
            if (!timezone)
              timezone = moment.tz.guess(); // User's timezone if not found

            // Filtering events which are 1 day older or less.
            var m1 = moment.tz(new Date().getTime(), timezone);
            let workHours = { work_hours_start: '07:00', work_hours_end: '17:00' };
            if (siteSelected.site_config && siteSelected.site_config.work_hours) {
              workHours = siteSelected.site_config.work_hours;
            }
            // console.log('workHours', workHours);
            function getEventStats(data) {
              var counts = { alert: 0, warning: 0 };
              var filteredEvents = (data).filter(evt => {
                var m2 = moment.tz(evt.timestamp, timezone);
                var diff = m1.diff(m2, 'days');

                var allowEvent = false;
                if (diff <= 1) {
                  let HHmm = moment.tz(evt.timestamp, timezone).format('HH:mm');
                  let day = moment.tz(evt.timestamp, timezone).format('dddd');
                  if (workHours.extended_enabled) {
                    for (const weekdays in workHours.work_schedule) {
                      let event_day = day.toLowerCase();
                      if (weekdays === event_day) {
                        let work_hours = workHours.work_schedule[event_day];

                        let HH = moment.tz(evt.timestamp, timezone).format('HH');
                        let mm = moment.tz(evt.timestamp, timezone).format('mm');

                        let wh_pos = parseInt(HH);
                        if (work_hours.length > 24) {
                          wh_pos = 2 * wh_pos;
                          if (mm > 30)
                            wh_pos = wh_pos + 1;
                        }

                        if (work_hours[wh_pos] === 1) {
                          counts[evt.event_level.toLowerCase()] += 1;
                          allowEvent = true;
                        }
                      }
                    }
                  } else {
                    if (HHmm >= workHours.work_hours_start && HHmm <= workHours.work_hours_end) {
                      counts[evt.event_level.toLowerCase()] += 1;
                      allowEvent = true;
                    }
                  }

                  evt.event_level = evt.event_level.toLowerCase();
                }
                return allowEvent;
              });
              let sortedZoneEvents = filteredEvents.sort((a, b) => b.timestamp - a.timestamp);
              return { events: sortedZoneEvents, counts: counts };
            }

            let zone_events = {};
            for (let x in res.data)
              zone_events[x] = getEventStats(res.data[x]);

            // console.log('zone_events', zone_events)
            resolve(zone_events);
          } else {
            resolve({});
          }
        },
        (res) => {
          resolve({});
        });
    });
  }

  const faIcons = { 'temperature': 'fa-thermometer-half', 'humidity': 'fa-tint', 'motion': 'fa-street-view', 'motion_security': 'fa-street-view text-danger', 'motion_ahours': 'fa-street-view', 'co': 'fa-info-circle', 'voc': 'fa-info-circle', 'vmotion_ahours': 'fa-car' };
  let eventsFound = false;
  let popoverContent = <div className="event_notifications">
    {zoneEventsInfo && zoneEventsInfo.map((eventInfo, z) => {
      if (eventInfo.events && eventInfo.events.length === 0)
        return "";

      eventsFound = true;
      return <div key={"event_" + z} className="mb-2">
        {eventInfo && eventInfo.events && eventInfo.events.length > 0 && <span className="zone_title">{eventInfo && eventInfo.zone && eventInfo.zone.location_name}</span>}
        {eventInfo && eventInfo.events && eventInfo.events.length > 0 && eventInfo.events.map((zone_event, z) =>
          <div className="notification-link m-2 p-1 cursor-pointer" onClick={() => navigate(eventInfo.zone, zone_event.dev_timestamp, zone_event.timestamp / 1000)} key={z} >
            <span className="zone_event">
              <i className={"fa " + faIcons[zone_event.sensor_id.split(':')[0]] + ' event-' + zone_event.event_level}> </i> {(zone_event.sensor_id.split(':')[0]).split('_').join(' ')}
            </span>
            <span className="pull-right font-size-12 pr-1 p-1">
              <Moment format="MMM DD, YYYY HH:mm" tz={timezone}>
                {zone_event.dev_timestamp * 1000}
              </Moment>
            </span>
            <br />
            <div className="text-capitalize text-wrap font-size-12 pt-2 pl-3" >
              {zone_event.event_message}
            </div>
          </div>
        )}
      </div>
    })}
  </div>;

  if (!eventsFound)
    popoverContent = <span className="font-size-13">No notifications found.</span>


  return (
    <div>
      {fetchNotifications && <Popover className="border-rounded" placement="bottomRight" content={popoverContent} title={<b>Notifications: {events_count > 0 ? events_count : ''}</b>}><span className="cursor-pointer"><i className="fas fa-bell text-white"></i><sup><span className="mr-2 text-danger">{events_count > 0 && events_count}</span></sup></span></Popover>}
    </div>
  );
}

export default Notifications;